<script setup lang="ts">
import { computed } from "vue";

interface OverlayProps {
    position?: "center" | "top";
    fadeOut?: boolean;
    zIndexLevel?: number;
}
const props = withDefaults(defineProps<OverlayProps>(), { 
    position: "center",
    zIndexLevel: 0
});
const emit = defineEmits(["click"]);

const handleClick = (event: MouseEvent) => {
    emit("click", event);
};

// Hierarchical z-index system: above Ask AI (10000) and sticky table headers (9999).
const zIndex = computed(() => {
    return 11000 + props.zIndexLevel;
});
</script>
<template>
    <div :class="['overlay', { center: position === 'center', top: position === 'top', fadeOut }]" :style="{ zIndex }" @click.self="handleClick">
        <slot></slot>
    </div>
</template>
<style scoped lang="scss">
@keyframes overlayFadeIn {
    from {
        background-color: rgb(32, 81, 248, 0);
    }

    to {
        background-color: rgb(32, 81, 248, 0.2);
    }
}
@keyframes overlayFadeOut {
    from {
        background-color: rgb(32, 81, 248, 0.2);
    }

    to {
        background-color: rgb(32, 81, 248, 0);
    }
}
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    animation: overlayFadeIn forwards 0.5s;

    &.fadeOut {
        animation: overlayFadeOut forwards 0.5s;
    }

    &.center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &.top {
        padding-top: 40px;
        & > * {
            margin: auto;
        }
    }
}
</style>
